/** Clears host and parent-domain Intercom cookies on shared browsers. */
export function clearIntercomCookies(): void {
  const names = document.cookie
    .split(';')
    .map((part) => part.trim().split('=')[0]);
  const hostParts = window.location.hostname.split('.');
  const domains = [
    '',
    ...hostParts.map(
      (_, index) => `; domain=.${hostParts.slice(index).join('.')}`
    ),
  ];
  const segments = window.location.pathname.split('/').filter(Boolean);
  const paths = [
    '/',
    ...segments.map((_, index) => `/${segments.slice(0, index + 1).join('/')}`),
  ];
  for (const name of names.filter((name) => name.startsWith('intercom-'))) {
    for (const domain of domains) {
      for (const path of paths) {
        document.cookie = `${name}=; Max-Age=0; path=${path}${domain}`;
      }
    }
  }
}
